import { createReducer } from '@reduxjs/toolkit'
import { set_sub } from "../confg";

const subcategories = createReducer([], {
    [set_sub]: (state, action) => {
        return action.payload
    }
});

export default subcategories;